import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import {IconButton} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import withPermissions from "../WithPermissions";
import { apiCall } from "../../helpers/MainHelper";
import Swal from "sweetalert2";

class MessagesTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending: true
        }
    }

    componentDidMount() {
        // Set pending to false after component mounts
        setTimeout(() => {
            this.setState({ pending: false });
        }, 100);
    }

    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };

    formatTime = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        const now = new Date();
        const diff = now.getTime() - date.getTime();
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));

        if (days === 0) {
            return date.toLocaleTimeString("tr-TR", {
                hour: "2-digit",
                minute: "2-digit",
            });
        } else if (days === 1) {
            return "Dün";
        } else if (days < 7) {
            return date.toLocaleDateString("tr-TR", { weekday: "short" });
        } else {
            return date.toLocaleDateString("tr-TR", {
                day: "numeric",
                month: "short",
            });
        }
    };

    handleDeleteConversation = async (customerId, event) => {
        event.stopPropagation(); // Prevent row click

        const result = await Swal.fire({
            title: 'Emin misiniz?',
            text: 'Bu konuşmayı silmek istediğinize emin misiniz?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Evet, Sil',
            cancelButtonText: 'İptal'
        });

        if (result.isConfirmed) {
            try {
                const response = await apiCall(`business/messages/${customerId}`, "delete", null);

                if (response && response.status === 'success') {
                    Swal.fire({
                        title: 'Silindi!',
                        text: 'Konuşma başarıyla silindi.',
                        icon: 'success',
                        timer: 1500,
                        showConfirmButton: false
                    });

                    // Refresh table
                    this.triggerFetch();
                } else {
                    throw new Error(response?.message || 'Konuşma silinemedi');
                }
            } catch (error) {
                console.error("Error deleting conversation:", error);
                Swal.fire({
                    title: "Hata",
                    text: error.response?.data?.message || error.message || "Konuşma silinirken bir hata oluştu.",
                    icon: "error",
                    confirmButtonText: "Tamam",
                });
            }
        }
    };

    render() {
        const {pending} = this.state;
        const {userPermissions} = this.props;
        const userHasViewCustomerPermission = userPermissions?.includes('view customer') || true;

        const columns = [
            {
                name: 'Müşteri',
                cell: row => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                            style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                                backgroundColor: "#007bff",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginRight: "12px",
                                fontSize: "16px",
                                fontWeight: "bold",
                            }}
                        >
                            {row.customer?.name?.charAt(0)?.toUpperCase() || "M"}
                        </div>
                        <div>
                            <strong>{row.customer?.name || "Müşteri"}</strong>
                            <br />
                            <small className="text-muted">{row.customer?.phone || ""}</small>
                        </div>
                    </div>
                ),
                sortable: false
            },
            {
                name: 'Son Mesaj',
                cell: row => (
                    <div>
                        <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", marginBottom: "4px" }}>
                            {row.last_message?.message || "Mesaj yok"}
                        </div>
                        <small className="text-muted">
                            {row.last_message?.sender_type === "customer" ? "Müşteri" : "Servis"}
                        </small>
                    </div>
                ),
                sortable: false
            },
            {
                name: 'Tarih',
                cell: row => this.formatTime(row.last_message?.created_at),
                sortable: true,
                selector: row => row.last_message?.created_at || ''
            },
            {
                name: 'Okunmamış',
                cell: row => (
                    row.unread_count > 0 ? (
                        <span className="badge badge-danger">{row.unread_count}</span>
                    ) : (
                        <span className="badge badge-secondary">0</span>
                    )
                ),
                sortable: true,
                selector: row => row.unread_count || 0
            },
            {
                name: 'İşlem',
                button: true,
                cell: row => (
                    <div style={{ display: 'flex', gap: '5px', justifyContent: 'center' }}>

                        <IconButton 
                            className="btn btn-outline-danger"
                            onClick={(e) => this.handleDeleteConversation(row.id, e)} 
                            style={{cursor: 'pointer', padding: '5px'}}
                            title="Sil"
                        >
                            <button type="button" className="btn btn-outline-danger btn-sm">
                                <i className="icon-trash"></i>
                            </button>
                        </IconButton>
                    </div>
                )
            }
        ];

        return (
            <>
                <style>
                    {`
                        .rdt_TableCell {
                            padding: 10px 12px !important;
                            vertical-align: middle;
                            text-align: center;
                        }
                        .rdt_TableHeadCell {
                            padding: 10px 12px !important;
                            font-weight: 600;
                            text-align: center !important;
                            vertical-align: middle;
                        }
                        .rdt_TableCell:first-child {
                            text-align: left !important;
                        }
                        .rdt_TableHeadCell:first-child {
                            text-align: left !important;
                        }
                    `}
                </style>
                <DataTable
                    ref={this.tableRef}
                    dataEndpoint={"business/messages/conversations"}
                    columns={columns}
                    onRowClicked={row => this.props.history.push(`/messages/${row.id}`)}
                    progressPending={pending}
                    extraQueryParams={{}}
                />
            </>
        )
    }
}

export default withPermissions(withRouter(MessagesTable));
